import React, { useState, useContext } from "react";
import { Button, Form, Input, Modal } from "antd";
import { omit } from "lodash";

import copy from "../../assets/images/webToLead/copy.png";
import { useLeadFormActions } from "./hooks/useLeadFormActions";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";

const Clone = ({ formData, setPage, isExpired, onSubscription }) => {
  const [form] = Form.useForm();
  const { showAlert } = useAlert();
  const { isWebToLeadCreate } = useContext(AuthContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newFormData, setNewFormData] = useState();
  const [isConfirm, setConfirm] = useState(false);
  const [error, setError] = useState();

  const { handleClone } = useLeadFormActions(
    () => {},
    () => {
      setConfirm(true);
      setIsModalOpen(false);
    },
  );

  const showModal = () => {
    if (isExpired) {
      onSubscription();
    } else {
      if (isWebToLeadCreate) {
        setIsModalOpen(true);
      } else {
        showAlert(
          "warning",
          "Permission Denied",
          "You do not have permission to create web to lead form.",
        );
      }
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setNewFormData();
    setError();
  };

  const onClone = async (values) => {
    setNewFormData(values);
    const payload = omit(
      {
        ...formData,
        ...values,
        createdDate: new Date(),
        updatedDate: new Date(),
      },
      ["id"],
    );
    const res = await handleClone(payload, 1, () => handleCancel());
    if (res?.status === "error") {
      setError(res?.message);
    }
    if (res?.data) {
      handleCancel();
      setPage(1);
    }
  };

  return (
    <>
      <div
        className="heading14px d-flex align-items-center"
        style={{ gap: 7, color: "#29292B", paddingRight: 30 }}
        onClick={showModal}
      >
        <img
          src={copy}
          alt=""
          style={{ width: 16, height: 16 }}
          className="cursor-pointer"
        />{" "}
        Clone
      </div>
      <Modal
        title={null}
        className="delete-popup"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div className="tw-bg-secondary-color tw-text-text-primary tw-text-lg tw-font-semibold tw-py-4 tw-px-6 tw-rounded-t-2xl">
          Create Title for Clone
        </div>

        <Form
          form={form}
          layout="vertical"
          initialValues={{ formName: "", domainName: "" }}
          onFinish={onClone}
        >
          <div
            style={{ padding: "0 24px 20px 24px" }}
            className="web-to-lead mt10"
          >
            {error && <p className="text-error text-center pb-2">{error}</p>}
            <Form.Item
              label="Form Name:"
              name="formName"
              rules={[{ required: true, message: "Please enter a form name" }]}
            >
              <Input className="common-input" placeholder="Enter New Name…" />
            </Form.Item>

            <Form.Item
              label="Your Domain Name:"
              name="domainName"
              rules={[
                { required: true, message: "Please enter a domain name" },
                {
                  pattern:
                    /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/,
                  message:
                    "Please enter a valid domain name (e.g., example.com)",
                },
              ]}
            >
              <Input
                className="common-input"
                placeholder="Enter Your Domain Name…"
              />
            </Form.Item>
          </div>
          <div className="tw-flex tw-bg-secondary-color tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-4">
            <Button
              className="tw-border-sub-text hover:!tw-border-sub-text tw-text-sm tw-text-sub-text hover:!tw-text-sub-text"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              className="!tw-bg-theme tw-font-medium !tw-outline-0 !tw-border-theme !tw-text-white tw-font-medium tw-text-sm"
              htmlType="submit"
            >
              Clone
            </Button>
          </div>
        </Form>
      </Modal>
      <Modal
        title="Subscription expired"
        open={isConfirm}
        centered
        width={400}
        footer={[
          <Button
            key="cancel"
            className="secondary-btn"
            onClick={() => {
              setNewFormData();
              setConfirm(false);
            }}
          >
            No
          </Button>,
          <Button
            key="ok"
            type="primary"
            className="theme-btn"
            onClick={() => {
              onClone({ ...newFormData, force: true });
              setConfirm(false);
            }}
          >
            Yes
          </Button>,
        ]}
        onOk={() => setConfirm(false)}
        onCancel={() => setConfirm(false)}
      >
        Your subscription has expired, but the grace period is still active. Do
        you want to continue for up to 7 more days?
      </Modal>
    </>
  );
};

export default Clone;
